import { render, staticRenderFns } from "./ModalTemplatesList.vue?vue&type=template&id=5e1295bc&scoped=true"
import script from "./ModalTemplatesList.vue?vue&type=script&lang=js"
export * from "./ModalTemplatesList.vue?vue&type=script&lang=js"
import style0 from "./ModalTemplatesList.vue?vue&type=style&index=0&id=5e1295bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1295bc",
  null
  
)

export default component.exports